import { getThumbmark } from '@thumbmarkjs/thumbmarkjs'

export interface DeviceFingerprint {
  fingerprint: string
  components: Record<string, unknown>
  deviceId?: string
  platform?: string
}

const DEVICE_ID_KEY = 'deviceId'
const FINGERPRINT_TIMEOUT_MS = 1500

let cached: Promise<DeviceFingerprint | null> | null = null

// Случайный идентификатор устройства в localStorage — переживает мелкие изменения отпечатка.
// В части Telegram WebView доступ к localStorage бросает исключение, поэтому всё в try/catch.
function getOrCreateDeviceId(): string | undefined {
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY)
    if (stored) return stored
    if (typeof crypto?.randomUUID !== 'function') return undefined
    const created = crypto.randomUUID()
    localStorage.setItem(DEVICE_ID_KEY, created)
    return created
  } catch {
    return undefined
  }
}

async function collect(): Promise<DeviceFingerprint | null> {
  // logging: false — не отправляем данные на сервер ThumbmarkJS
  const result = await getThumbmark({ logging: false, timeout: FINGERPRINT_TIMEOUT_MS })
  if (!result?.thumbmark) return null
  const tg = window.Telegram?.WebApp
  return {
    fingerprint: result.thumbmark,
    components: {
      ...(result.components as Record<string, unknown>),
      telegram: { platform: tg?.platform, version: tg?.version },
    },
    deviceId: getOrCreateDeviceId(),
    platform: tg?.platform,
  }
}

/**
 * Отпечаток устройства для антибот-проверок. Никогда не бросает и не блокирует логин:
 * при ошибке или таймауте возвращает null. Считается один раз за сессию.
 */
export function getDeviceFingerprint(): Promise<DeviceFingerprint | null> {
  if (!cached) {
    const timeout = new Promise<null>((resolve) => setTimeout(() => resolve(null), FINGERPRINT_TIMEOUT_MS))
    cached = Promise.race([collect().catch(() => null), timeout])
  }
  return cached
}
